var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsLightWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols-light:work",
    clipPath: "url(#clip0_108_225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.2411 53.1592C15.1622 52.5363 14.4701 51.6551 14.1647 50.5156C13.8587 49.3736 14.0172 48.2632 14.6401 47.1843L27.8703 24.2689C28.4932 23.1899 29.3752 22.4983 30.5163 22.1939C31.6567 21.887 32.7663 22.045 33.8453 22.6679L44.1302 28.6059L46.0057 25.3574C46.6287 24.2785 47.5106 23.5868 48.6517 23.2824C49.7921 22.9755 50.9018 23.1335 51.9807 23.7564L58.4777 27.5075C59.5566 28.1304 60.2491 29.0128 60.555 30.1548C60.8604 31.2943 60.7016 32.4035 60.0787 33.4824L58.2031 36.7309L68.4881 42.6689C69.567 43.2919 70.2587 44.1738 70.5631 45.3149C70.87 46.4553 70.712 47.5649 70.0891 48.6439L56.8589 71.5593C56.2359 72.6382 55.3547 73.3303 54.2152 73.6356C53.0733 73.9416 51.9628 73.7832 50.8839 73.1602L16.2411 53.1592ZM46.4757 29.9601L55.8577 35.3767L57.7332 32.1282C57.9408 31.7686 57.9816 31.3512 57.8557 30.8761C57.7272 30.4017 57.4832 30.0606 57.1235 29.853L50.6265 26.1019C50.2669 25.8943 49.8495 25.8535 49.3744 25.9794C48.8999 26.1079 48.5589 26.3519 48.3512 26.7116L46.4757 29.9601Z",
    fill: "#87CBC5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white",
    transform: "translate(32.5) rotate(30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsLightWork);
export default __webpack_public_path__ + "static/media/material-symbols-light_work.738109ca5e3da23f3ae71b3b581784f0.svg";
export { ForwardRef as ReactComponent };